<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 pb4 mb2 shadow">
          <div class="col-12 p2">
            <p class="h4 semi-bold darkblue line-height-4 gibson">
              Køb flere projekter
            </p>
          </div>
          <div class="col-12 px2">
            <purchase></purchase>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import purchase from './purchase/Koeb'
export default {
  components: {
    purchase
  }
}
</script>
<style scoped>
.main .container-fluid {
  padding: 15px 0;
}
.fa-cart-plus {
  font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// Purchase.vue?8956e0b0